<template>
	<div :class="['infobar', { blue: blue, fat: fat }]" v-if="show">
		<div class="infobar__icon">
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:class="'infobar__icon'" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M11 10h2v8h-2z"/><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"/><path d="M11 6h2v2h-2z"/></svg>
		</div>
		<div class="infobar__text">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AlertMessage',
	props: {
		show: {
			type: Boolean,
			default: false
		},
		blue: {
			type: Boolean,
			default: false
		},
		fat: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.infobar {
	padding: 20px 20px 15px;
	background-color: orange;
	display: flex;
	flex-direction: row;

	&.fat {
		font-weight: 500;
	}

	&.blue {
		background-color: $colorPrimary8;
		// border-left: 4px solid $colorRed;
		color: white;

		p {
			color: white;
			
			a {
				color: white;
				text-decoration: underline;

				&:hover {
					text-decoration: none;
				}
			}
		}

		.infobar__icon {
			svg {
				fill: white;
			}
		}
	}

	&__icon {
		svg {
			fill: $colorPrimary;
			width: 25px;
			height: 25px;
		}
	}

	&__text {
		margin-left: 10px;
	}

	&__message {
		margin-bottom: 10px;
	}

	p {
		text-align: left;
	}

	a,
	&__message-link {
		color: inherit;
	}
}
</style>
